import {
  DepositCondition,
  DepositType,
  FormConditionCondition,
} from '@urbanx/agx.campaigns.client'
import { useMemo } from 'react'
import {
  ConditionFromOptions,
  InitialDepositOnDateOptions,
  BalanceDepositOnDateOptions,
  InitialDepositNDaysOptions,
  BalanceDepositNDaysOptions,
} from './ConditionFromOptions'

export const useFormConditionDateOptions = (
  dateOptions: FormConditionCondition[],
  useOnDateVariant = false,
  depositType?: DepositType
) => {
  return useMemo(() => {
    let optionsToUse = ConditionFromOptions

    // For deposits, choose appropriate options based on type and segment
    if (depositType !== undefined) {
      if (useOnDateVariant) {
        // "On..." segment
        optionsToUse =
          depositType === DepositType.Initial
            ? InitialDepositOnDateOptions
            : BalanceDepositOnDateOptions
      } else {
        // "# days from..." segment
        optionsToUse =
          depositType === DepositType.Initial
            ? InitialDepositNDaysOptions
            : BalanceDepositNDaysOptions
      }
    }

    return optionsToUse.filter((option) => {
      if (option.value === '') return true

      // For OnDate variant, include OnDate when OnDate or NdaysFromDate is in dateOptions
      if (useOnDateVariant && option.value === DepositCondition.OnDate) {
        return (
          dateOptions.includes(FormConditionCondition.OnDate) ||
          dateOptions.includes(FormConditionCondition.NdaysFromDate)
        )
      }

      return dateOptions.includes(option.value as FormConditionCondition)
    })
  }, [dateOptions, useOnDateVariant, depositType])
}
